import { Heading, Spinner, Text } from "@instructure/ui";
import { t } from "i18next";

const ProgressBody = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <Heading as="h3">{t("finalizeCourse.finalizingResults")}</Heading>
      <div style={{ marginBottom: 10 }}>
        <Spinner renderTitle={t("global.pleaseWait")} margin="small 0" />
      </div>
      <Text size="medium" as="p" weight="bold" color="primary">
        {t("finalizeCourse.progressBody")}
      </Text>
    </div>
  );
};

export default ProgressBody;
